import { useTranslation } from '@/lib/i18n';

export function HeroBanner() {
  const { t } = useTranslation();
  return (
    <section
      aria-label={t('hero.title')}
      className="px-4 py-4 text-white"
      style={{ background: 'var(--brand-navy,#0A1128)' }}
    >
      <div className="flex items-center gap-2 mb-2">
        <span
          className="status-dot w-2 h-2 rounded-full"
          style={{ background: 'var(--brand-primary,#22D3EE)' }}
          aria-hidden="true"
        />
        <span
          className="text-[10px] font-semibold"
          style={{ color: 'rgba(255,255,255,0.85)', letterSpacing: '0.02em' }}
        >
          {t('hero.status')}
        </span>
      </div>
      <h1
        className="text-xl font-bold leading-tight mb-0.5"
        style={{ fontFamily: 'var(--brand-font-display)', letterSpacing: '-0.01em' }}
      >
        {t('hero.title')}
      </h1>
      <p className="text-xs" style={{ color: 'rgba(255,255,255,0.92)' }}>
        {t('hero.meta')}
      </p>
    </section>
  );
}
